import { render, staticRenderFns } from "./HighlightSlider.vue?vue&type=template&id=f0166456&shadow"
import script from "./HighlightSlider.vue?vue&type=script&lang=ts&shadow"
export * from "./HighlightSlider.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./HighlightSlider.vue?vue&type=style&index=0&id=f0166456&prod&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports